module.exports = __webpack_public_path__ + "static/img/tvvideo12_icon1.2dfb1871.png";